import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import themeable from 'zignal-landscape/lib/themeable';

const PageHeader = ({ styles, isScrolled, children }) => {
  const headerClasses = {
    [styles.PageHeader]: true,
    [styles.isScrolled]: isScrolled
  };
  return (
    <div className={classnames(headerClasses)}><div>{children}</div></div>
  );
};

PageHeader.propTypes = {
  styles: PropTypes.object.isRequired,
  isScrolled: PropTypes.bool,
  children: PropTypes.node
};

export default themeable(PageHeader);
